module.exports = __webpack_public_path__ + "static/img/公司.d5270b55.png";